'use client';

import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from '../index.module.scss';
import ClientComp from './ClientComp';
import IconClose from './IconClose';

export default function Content({ activeType, data, creditsData, callback, winCallback, itemCallback }: any) {
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);
    // tab点击切换
    const tabCallback = (item: any) => {
        callback && callback(item);
    };
    const closeHandle = () => {
        winCallback && winCallback('close');
    };
    if (isClient) {
        return ReactDOM.createPortal(
            <div className={`glo-editor-modal glo-editor-modal-show ${styles['eco-win']}`}>
                <div className={`glo-editor-modal-content eco-redeem-rewards-winall scrollbar-editor-white ${styles.content}`}>
                    <div className="glo-editor-modal-header">
                        <IconClose onClick={closeHandle} />
                    </div>
                    <ClientComp data={data} creditsData={creditsData} activeType={activeType} callback={tabCallback} itemCallback={itemCallback} />
                </div>
            </div>,
            document.body,
        );
    }
    return null;
}
